import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import '@fortawesome/fontawesome-free/css/all.css'
import { setupAxiosAuth } from './utils/auth.js'

const app = createApp(App)
setupAxiosAuth()

app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})

app.mount('#app')
